export default __webpack_public_path__ + "static/media/user_vip.d072fc9d.svg";